<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import { Routes } from '@/const/Routes'
  import VgsButton from '@/components/common/VgsButton.vue'
  import FileDownloadButton from '@/components/common/FileDownloadButton.vue'
  import { useAppRouting } from '@/composables/useAppRouting'
  import type { SubjectGuide } from '@/types/SubjectGuide'
  import type { AnnualPlan } from '@/types/Subject'

  const { isTeacher, subjectGuide, annualPlan } = defineProps<{
    isTeacher: boolean
    subjectGuide?: SubjectGuide
    annualPlan?: AnnualPlan
  }>()

  const { t } = useI18n()
  const { getRouteWithParams } = useAppRouting()
</script>

<template>
  <div v-if="isTeacher" class="teacher-aids">
    <router-link
      v-if="subjectGuide"
      :to="getRouteWithParams(Routes.SubjectGuide, subjectGuide)"
      class="to-teacher-button"
    >
      <VgsButton
        type="label"
        variant="quaternary"
        shape="rounded"
        icon-left="info-circle"
        data-testid="subject-guide"
      >
        {{ t('subject.to-teacher-subject') }}
      </VgsButton>
    </router-link>

    <FileDownloadButton
      v-if="annualPlan?.file"
      v-bind="annualPlan.file"
    />
  </div>
</template>

<style lang="scss" scoped>
  .teacher-aids {
    display: flex;
    gap: 24px;
  }
  </style>